import { Card, Modal } from 'antd';
import { useMemo } from 'react';
import { useStoreActions } from '../../../store';
import { TenantSelectTable } from '../../fulfillmentContext/shared/TenantSelectTable';

export interface TenantSelectModalProps {
  open?: boolean;
  onSelectedTenantsChange: (o: Record<string, boolean>) => void;
  selectedTenants: Record<string, boolean>;
}
export const TENANT_SELECT_MODAL_KEY = 'tenant-select-modal-key';
export const TenantSelectModal = ({ open, onSelectedTenantsChange, selectedTenants }: TenantSelectModalProps) => {
  const toggleModal = useStoreActions((actions) => actions.navigation.toggleModal);
  const selectedTenantIds = useMemo(() => {
    return Object.entries(selectedTenants).reduce((prev: string[], e) => {
      const [k, v] = e;
      return v ? [...prev, k] : prev;
    }, []);
  }, [selectedTenants]);
  return (
    <Modal
      width={900}
      open={open}
      closable={false}
      onOk={() => {
        toggleModal({ open: false, key: TENANT_SELECT_MODAL_KEY });
      }}
      onCancel={() => {
        toggleModal({ open: false, key: TENANT_SELECT_MODAL_KEY });
        onSelectedTenantsChange({});
      }}
    >
      <Card title="Select Tenants">
        {selectedTenantIds?.length ?? 0} tenants selected
        <TenantSelectTable
          selectedTenantIds={selectedTenantIds}
          allowMultiple={true}
          onSelect={(val) => {
            onSelectedTenantsChange({
              ...selectedTenants,
              [val]: !selectedTenants[val],
            });
          }}
        />
      </Card>
    </Modal>
  );
};
